// extracted by mini-css-extract-plugin
export var dateTimeButton = "_gv-1";
export var dateTimeButtonsContainer = "_gv-6";
export var dateTimeInputContainer = "_gv-7";
export var dateTimeWrapper = "_gv-8";
export var disabledTile = "_gv-0";
export var header = "_gv-2";
export var line = "_gv-3";
export var snoozeOption = "_gv-4";
export var time = "_gv-5";
export var todayTile = "_gv-9";
export var wrapper = "_gv-a";